export default __webpack_public_path__ + "static/media/spain.94bc7cd5.jpg";